// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"99b55129","55":"74665d4e","453":"d404293b","707":"79c1110d","790":"b4a17b5b"}[chunkId] + ".chunk.js";
};